export const validateEgyptianPhoneNumber = (phoneNumber) => {
  const errors = [];
  const phoneRegex = /^(?:\+20|0)(10|11|12|15)\d{8}$/;

  if (!phoneRegex.test(phoneNumber)) {
    errors.push("الرقم غير مناسب");
  }

  return errors;
};
